import { cardCollectorNumber } from './cardCollectorNumber.js';

/**
 * The `b` rune (OGN-126b, SFD-R04b, VEN-R04b, …) is the organized-play prize,
 * one per domain. Six domains across Origins, Spiritforged, Unleashed,
 * Vendetta, and Radiance, plus Unleashed's extra `c` prize, is 36.
 * Unleashed `b`/`c` and Radiance `b` are already filed under OPP. The other
 * `b` faces were imported as pack cards and have to be included by this rule.
 */
export function isOrganizedPlayPromoRune(card) {
  const type = String(card?.cardType || card?.card_type || '').toLowerCase();
  if (type !== 'rune') return false;
  return /b$/i.test(cardCollectorNumber(card));
}

/**
 * Product-set rows only. OPP/PR/JDG copies already match the promo set code,
 * so this must not be OR'd in a way that double-counts them.
 */
export const ORGANIZED_PLAY_PROMO_RUNE_SQL = `
  card_type = 'Rune'
  AND upper(set_code) NOT IN ('JDG', 'OPP', 'PR')
  AND (
    COALESCE(card_data->>'number', '') ~* 'b$'
    OR COALESCE(riftbound_id, '') ~* 'b(-|$)'
  )
`;
